/* @generated */

// src/assets/ui-icon/line/add-to-library.tsx
import * as React from "react";
var AddToLibraryLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.5 13v-2h-2V9.5h2v-2H13v2h2V11h-2v2h-1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.25V17.5c0 .85.2 1.465.62 1.88.415.42 1.03.62 1.88.62h10v-1.5h-10c-.4 0-.705-.065-.825-.185-.11-.11-.175-.41-.175-.815 0-.405.065-.705.185-.825.11-.11.41-.175.815-.175h10V4H8.25A2.248 2.248 0 0 0 6 6.25Zm2.25-.75a.748.748 0 0 0-.75.75v8.871a3.698 3.698 0 0 1 1-.121H17V5.5H8.25Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  AddToLibraryLine
};
